// Detects whether a route param is a UUID or a slug.
const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const isUuid = (value: string | undefined | null): boolean =>
  !!value && UUID_REGEX.test(value);

/** Returns the column to filter on for a given route param. */
export const idOrSlugColumn = (value: string | undefined | null): 'id' | 'slug' =>
  isUuid(value) ? 'id' : 'slug';
